import React from 'react';
import styles from './AboutPage.module.css';

const valueProps = [
  {
    icon: 'fas fa-shield-alt',
    title: 'الأمان والخصوصية',
    description: 'نحمي بياناتك وملفاتك بأحدث التقنيات لضمان تجربة آمنة تماماً.',
  },
  {
    icon: 'fas fa-rocket',
    title: 'الابتكار المستمر',
    description: 'نبحث دائماً عن طرق جديدة لتحسين خدماتنا وتجاوز توقعاتك.',
  },
  {
    icon: 'fas fa-user-friends',
    title: 'التركيز على المستخدم',
    description: 'احتياجاتك هي أولويتنا، ونصمم كل خدمة لتلبية توقعاتك.',
  },
  {
    icon: 'fas fa-check-circle',
    title: 'الجودة والموثوقية',
    description: 'نلتزم بتقديم محتوى عالي الجودة وبث موثوق به دائماً.',
  },
];

function AboutPage() {
  return (
    <div className={styles.aboutContainer}>


      <section className={styles.section}>
        <div className={styles.contentCard}>
          <h2 className={styles.sectionHeading}><i className="fas fa-lightbulb"></i> قصتنا ورؤيتنا</h2>
          <p>
            تأسست <span className={styles.highlight}>Zoon.sat</span> على رؤية بسيطة: جعل المحتوى الرقمي عالي الجودة في متناول الجميع، بسهولة وأمان. بدأنا كخدمة تحميل ملفات بسيطة، وتطوّرنا لنقدم تجربة بث تلفزيوني مباشر لا مثيل لها.
          </p>
          <p>
            هدفنا هو بناء مجتمع رقمي يثق بنا للحصول على أحدث الملفات ومشاهدة قنواتهم المفضلة دون عوائق. نحن نؤمن بأن الوصول إلى المعرفة والترفيه حق للجميع، ونسعى جاهدين لتحقيق ذلك عبر منصتنا المتطورة.
          </p>
          <p>
            نسعى دائمًا للابتكار وتوسيع خدماتنا، مع الالتزام بالجودة والأمان وتقديم أفضل تجربة ممكنة لمستخدمينا الكرام.
          </p>
        </div>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionHeading}><i className="fas fa-handshake"></i> قيمنا الأساسية</h2>
        <div className={styles.valuePropsGrid}>
          {valueProps.map(({ icon, title, description }) => (
            <div key={title} className={styles.valuePropItem}>
              <div className={styles.iconWrapper}><i className={icon}></i></div>
              <h3>{title}</h3>
              <p>{description}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default AboutPage;
